import { call, put, takeLatest } from 'redux-saga/effects'
import { webApi } from 'lib/api'
import { errorWrap, forwardPageError } from 'lib/saga-helpers'
import { constants, setResetPasswordField } from './actions'
import * as analytics from 'lib/analytics'

export function * submit ({ payload: { mode, fields: { email, password }, resetPasswordToken } }) {
  const endpoints = {
    beginResetPassword: '/users/reset-password',
    endResetPassword: '/users/reset-password'
  }
  const payloads = {
    endResetPassword: {
      password,
      resetPasswordToken
    }
  }
  if (mode === 'beginResetPassword') {
    const { data } = yield call(webApi.get, `${endpoints[mode]}/${email}`)
    if (data.reason === 'PASSWORD_NOT_FOUND') {
      yield put({
        type: constants.RESET_PASSWORD_NOT_FOUND
      })
    } else {
      yield put({
        type: constants.RESET_PASSWORD_LINK_SENT
      })
    }
  } else if (mode === 'endResetPassword') {
    const { data } = yield call(webApi.post, endpoints[mode], payloads[mode])
    if (data.success === true) {
      yield put({
        type: constants.RESET_PASSWORD_SUBMIT_SUCCESS
      })
    } else {
      if (data.reason === 'SAME_PASSWORD') {
        yield put(setResetPasswordField('password', password, { message: 'Please use a password that is different from your current password' }))
        yield put({
          type: constants.RESET_PASSWORD_SUBMIT_FAILURE
        })
      } else if (data.reason === 'LINK_NOT_FOUND') {
        yield put({
          type: constants.RESET_PASSWORD_LINK_NOT_FOUND
        })
      } else if (data.reason === 'LINK_EXPIRED') {
        yield put({
          type: constants.RESET_PASSWORD_EXPIRED
        })
      }
    }
  }

  if (mode === 'beginResetPassword') {
    analytics.event({
      category: 'User',
      action: 'Begin Reset Password'
    })
  } else if (mode === 'endResetPassword') {
    analytics.event({
      category: 'User',
      action: 'End Reset Password'
    })
  }
}

export function * verifyResetPasswordToken ({ payload: resetPasswordToken }) {
  const { data } = yield call(webApi.get, `/users/reset-password/verify/${resetPasswordToken}`)
  if (data.success === false) {
    if (data.reason === 'LINK_NOT_FOUND') {
      yield put({
        type: constants.RESET_PASSWORD_LINK_NOT_FOUND
      })
    } else if (data.reason === 'LINK_EXPIRED') {
      yield put({
        type: constants.RESET_PASSWORD_EXPIRED
      })
    }
  }
}

export default function * rootSaga () {
  yield takeLatest(
    constants.RESET_PASSWORD_SUBMIT,
    errorWrap(submit, null, forwardPageError('*'))
  )
  yield takeLatest(
    constants.VERIFY_RESET_PASSWORD_TOKEN,
    errorWrap(verifyResetPasswordToken, null, forwardPageError('*'))
  )
}
